import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { TooltipRenderProps } from "react-joyride";
import { resetWhiteLabelJR } from "../../../../helpers";
import { whiteLabelJRStep } from "../../../../qraphql/globalVar/state";

export const ContinueEducationTooltip = ({
  index,
  step,
  size,
  tooltipProps,
}: TooltipRenderProps) => {
  const { t } = useTranslation();
  const percent = ((index + 1) / size) * 100;
  const whiteLabelJRStepValue = useReactiveVar(whiteLabelJRStep);

  const handleCloseClick: React.MouseEventHandler = () => {
    resetWhiteLabelJR();
  };

  const handlePrimaryClick: React.MouseEventHandler = () => {
    whiteLabelJRStep(whiteLabelJRStepValue + 1);
  };

  return (
    <div
      {...tooltipProps}
      className="bg-white rounded-4 overflow-hidden"
      style={{ width: 350 }}
    >
      <ProgressBar variant="success" now={percent} style={{ height: "8px" }} />
      <div className="p-3">
        <div className="d-flex gap-3">
          <div>
            <ArrowLeft width={14} height={14} />
          </div>
          <div>
            <div className="fw-bold mb-2">{step.title}</div>
            <div className="fs-7">{step.content}</div>
          </div>
        </div>
        <hr className="border border-2 border-top border-secondary" />
        <Button
          variant="success"
          className="w-100"
          onClick={handlePrimaryClick}
          size="sm"
        >
          {t("whiteLabelSteps.Continue Education")}
        </Button>
        <div className="d-flex justify-content-center mt-2">
          <Button
            variant="link"
            className="fw-normal text-success"
            size="sm"
            onClick={handleCloseClick}
          >
            {t("whiteLabel.Skip Education")}
          </Button>
        </div>
      </div>
    </div>
  );
};
